// extracted by mini-css-extract-plugin
export default {"Loading":"Post_Loading__WFfDi"};